import React, { useContext, useState, useRef } from "react";
import { Authorization, Datas, TokenContext } from "../App";
import { useNavigate } from 'react-router-dom';
import p from '../styles/Profile.module.css';
import BackHome from "../components/BackHome";

// ANDROID
import photoAndroid from '../assets/photo/happ_market.jpg';
import photoAndroid3 from '../assets/photo/step2.jpg';
import photoAndroid4 from '../assets/photo/step4.jpg';

// WINDOWS
import photoWin from '../assets/photo/photoWin.png';
import photoWin2 from '../assets/photo/photoWin2.png';
import photoWin3 from '../assets/photo/photoWin3.png';
import photoWin4 from '../assets/photo/photoWin4.png';

// IOS
import photoIos from '../assets/photo/photoIos.png';
import photoIos2 from '../assets/photo/photoIos2.png';
import photoIos3 from '../assets/photo/photoIos3.jpg';
import photoIos4 from '../assets/photo/photoIos4.png';
import photoIos5 from '../assets/photo/photoIos5.png';
import photoIos6 from '../assets/photo/photoIos6.png';
import photoIos7 from '../assets/photo/photoIos7.png';

const API = 'https://libervpn.ru/api';

interface StepItem {
    text: string;
    href?: string | null;
    photo?: string;
    child?: React.ReactNode;
}

function pluralize(num: number, one: string, few: string, many: string): string {
    const n = Math.abs(num) % 100;
    const n1 = n % 10;
    if (n > 10 && n < 20) return `${num} ${many}`;
    if (n1 > 1 && n1 < 5) return `${num} ${few}`;
    if (n1 === 1) return `${num} ${one}`;
    return `${num} ${many}`;
}

function formatTimeLeft(totalDays: number): string {
    if (!totalDays || totalDays <= 0) return "0 дней";

    const years = Math.floor(totalDays / 365);
    const remainingAfterYears = totalDays % 365;
    const months = Math.floor(remainingAfterYears / 30);
    const days = remainingAfterYears % 30;

    const parts: string[] = [];

    if (years > 0) parts.push(pluralize(years, 'год', 'года', 'лет'));
    if (months > 0) parts.push(pluralize(months, 'месяц', 'месяца', 'месяцев'));
    if (days > 0) parts.push(pluralize(days, 'день', 'дня', 'дней'));

    return parts.length > 0 ? parts.join(', ') : "0 дней";
}

function Profile(): React.ReactElement {
    const authorization = useContext(Authorization);
    const jwt_context = useContext(TokenContext);
    const data = useContext<any>(Datas);
    const navigate = useNavigate();

    const [copied, setCopied] = useState<boolean>(false);
    const [active, setActive] = useState<string>('');
    const [refCopied, setRefCopied] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const androidRef = useRef<HTMLDivElement>(null);
    const iosRef = useRef<HTMLDivElement>(null);
    const windowsRef = useRef<HTMLDivElement>(null);
    const macosRef = useRef<HTMLDivElement>(null);
    const linuxRef = useRef<HTMLDivElement>(null);

    const refUrl: string = data?.datas?.referral_url || `https://libervpn.ru/?ref=${data?.datas?.username || ''}`;
    const subUrl: string = `https://lidervpn.ru:8000${data?.datas?.sub_url || ''}`;

    const daysLeft = Math.ceil(((data?.datas?.limit || 0) - Math.floor(Date.now() / 1000)) / 86400);
    const formattedTimeLeft = formatTimeLeft(daysLeft);

    const CopyRefUrl = (): void => {
        navigator.clipboard.writeText(refUrl);
        setRefCopied(true);
        setTimeout(() => setRefCopied(false), 2000);
    };

    const CopyUrl = (): void => {
        navigator.clipboard.writeText(subUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    async function LogOut(): Promise<void> {
        try {
            await fetch(`${API}/logout`, { credentials: 'include' });
            jwt_context?.setToken?.('');
            authorization?.setAuth?.(false);
            navigate('/');
        } catch (err) {
            console.error(err);
        }
    }

    function toggle(name: string): void {
        setActive(prev => (prev === name ? '' : name));
    }

    function getHeight(ref: React.RefObject<HTMLDivElement | null>, name: string): string {
        if (active === name && ref.current) {
            return `${ref.current.scrollHeight}px`;
        }
        return '0px';
    }

    const androidSteps: StepItem[] = [
        { text: 'Скачайте приложение Happ из Google Play', href: 'https://play.google.com/store/apps/details?id=com.happproxy', photo: photoAndroid },
        { text: 'Скопируйте выданную ссылку', href: null },
        { text: 'Нажмите на плюс', href: null, photo: photoAndroid3 },
        { text: 'Вставить из буфера обмена', href: null, photo: photoAndroid4 },
    ];

    const iosSteps: StepItem[] = [
        { text: 'Скачайте приложение OneXray из App Store', href: 'https://apps.apple.com/ru/app/onexray/id6745748773', photo: photoIos5 },
        { text: 'Выберите RU', href: null, photo: photoIos },
        { text: 'Разрешите добавление VPN конфигураций', href: null, photo: photoIos2 },
        { text: 'Нажмите на плюс', href: null, photo: photoIos3 },
        { text: 'Выберите "подписка"', href: null, photo: photoIos4 },
        { text: 'Придумайте имя и вставьте выданную в профиле ссылку', href: null, photo: photoIos6 },
        { text: 'Выберите сервер', href: null, photo: photoIos7 }
    ];

    const windowsSteps: StepItem[] = [
        { text: 'Скачайте приложение Happ', href: 'https://www.happ.su/main', photo: photoWin },
        { text: 'Установите скачанное приложение', href: null, photo: photoWin2 },
        { text: 'Скопируйте вашу ссылку на подписку из личного кабинета', href: null },
        { text: 'В программе вставьте ссылку', href: null, photo: photoWin3 },
        { text: 'Нажмите кнопку "Подключить" для запуска VPN', href: null, photo: photoWin4 },
    ];

    const macosSteps: StepItem[] = [
        { text: 'Скачайте приложение FoXray или V2Box из Mac App Store', href: 'https://apps.apple.com/ru/app/foxray/id6448898374' },
        { text: 'Скопируйте ссылку на подписку из вашего профиля', href: null },
        { text: 'Откройте приложение, перейдите в раздел "Subscriptions" (Подписки)', href: null },
        { text: 'Нажмите на кнопку "+" (Добавить) и вставьте скопированную ссылку', href: null },
        { text: 'Обновите подписку, выберите нужную локацию и нажмите кнопку "Старт"', href: null },
    ];

    const linuxSteps: StepItem[] = [
        { text: 'Установите приложение Hiddify под вашу ОС из официальных релизов', href: 'https://github.com/hiddify/hiddify-app/releases' },
        { text: 'Откройте приложение Hiddify и вверху нажмите кнопку «+». Выберите «Добавить из буфера»', href: null },
        { text: 'Убедитесь, что подписка добавилась – внизу появится список стран, которые доступны для вашей подписки', href: null },
        { text: 'Нажмите вверху большую кнопку включения. VPN запущен!', href: null },
        { text: 'Вы можете изменить страну подключения, просто выбрав нужную локацию в списке', href: null },
    ];

    const renderSteps = (stepsArray: StepItem[]): React.ReactElement => {
        return (
            <div className={p.steps}>
                {stepsArray.map((step, i) => (
                    <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                        <div className={p.step_row}>
                            <div className={p.step_num}>{i + 1}</div>
                            <div className={p.step_text}>
                                {step.href ? (
                                    <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                        {step.text}
                                    </a>
                                ) : (
                                    <span>{step.text}</span>
                                )}
                                {step.child && step.child}
                            </div>
                        </div>
                        {step.photo && (
                            <img
                                src={step.photo}
                                className={p.step_photo}
                                alt={`Шаг ${i + 1}`}
                                style={{ marginBottom: i !== stepsArray.length - 1 ? '12px' : '0px' }}
                            />
                        )}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <>
            <BackHome />
            <div className={p.page}>
                {/* Карточка профиля */}
                <div className={p.profile_card}>
                    <div className={p.avatar}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5">
                            <circle cx="12" cy="8" r="4" />
                            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                        </svg>
                    </div>
                    <div className={p.profile_info}>
                        <p className={p.username}>Добрый день, {data?.datas?.username}</p>
                        <p className={p.days}>
                            Подписка истекает через {data?.datas?.free_trial ? formattedTimeLeft : '-'}
                        </p>

                        <div className={p.sub_row}>
                            <p className={p.sub_label}>Ссылка на подписку:</p>
                            {data?.datas?.free_trial
                                ? <a className={p.sub_link} href={subUrl}>{subUrl}</a>
                                : <p>Подписка не активирована</p>
                            }
                            <button className={p.copy_btn} onClick={CopyUrl}>
                                {copied ? (
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                ) : (
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" />
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>
                                )}
                            </button>
                        </div>

                        {!data?.datas?.free_trial && (
                            <button
                                className={p.activate_btn}
                                onClick={async () => {
                                    setIsLoading(true);
                                    try {
                                        const response = await fetch(`${API}/adduser`, {
                                            headers: { 'authorization': `${jwt_context?.token || ''}` }
                                        });
                                        const res = await response.json();
                                        if (response.ok) {
                                            data?.setDatas?.((prev: any) => ({
                                                ...prev,
                                                sub_url: res.subscription,
                                                limit: res.expire,
                                                free_trial: true
                                            }));
                                        }
                                    } catch (err) {
                                        console.error(err);
                                    } finally {
                                        setIsLoading(false);
                                    }
                                }}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <svg className={p.spinner} viewBox="0 0 50 50">
                                        <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                    </svg>
                                ) : (
                                    'Активировать бесплатный период'
                                )}
                            </button>
                        )}

                        <div className={p.sub_row}>
                            <p className={p.sub_label}>Реферальная ссылка:</p>
                            <a className={p.sub_link} href={refUrl}>{refUrl}</a>
                            <button className={p.copy_btn} onClick={CopyRefUrl}>
                                {refCopied ? (
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                ) : (
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
                                        <rect x="9" y="9" width="13" height="13" rx="2" />
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>
                                )}
                            </button>
                        </div>

                        <button onClick={LogOut} className={p.logout_btn}>
                            Выход с аккаунта
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                <polyline points="16 17 21 12 16 7" />
                                <line x1="21" y1="12" x2="9" y2="12" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Инструкция Android */}
                <div className={p.section} onClick={() => toggle('android')}>
                    <p className={p.section_title}>
                        Инструкция по настройке Android:
                        <span className={`${p.arrow} ${active === 'android' ? p.arrow_open : ''}`}>▾</span>
                    </p>
                    <div
                        ref={androidRef}
                        className={p.instruction_body}
                        style={{
                            maxHeight: getHeight(androidRef, 'android'),
                            opacity: active === 'android' ? 1 : 0,
                        }}
                    >
                        {renderSteps(androidSteps)}
                    </div>
                </div>

                {/* Инструкция iOS */}
                <div className={p.section} onClick={() => toggle('ios')}>
                    <p className={p.section_title}>
                        Инструкция по настройке iOS:
                        <span className={`${p.arrow} ${active === 'ios' ? p.arrow_open : ''}`}>▾</span>
                    </p>
                    <div
                        ref={iosRef}
                        className={p.instruction_body}
                        style={{
                            maxHeight: getHeight(iosRef, 'ios'),
                            opacity: active === 'ios' ? 1 : 0,
                        }}
                    >
                        {renderSteps(iosSteps)}
                    </div>
                </div>

                {/* Инструкция Windows */}
                <div className={p.section} onClick={() => toggle('windows')}>
                    <p className={p.section_title}>
                        Инструкция по настройке Windows:
                        <span className={`${p.arrow} ${active === 'windows' ? p.arrow_open : ''}`}>▾</span>
                    </p>
                    <div
                        ref={windowsRef}
                        className={p.instruction_body}
                        style={{
                            maxHeight: getHeight(windowsRef, 'windows'),
                            opacity: active === 'windows' ? 1 : 0,
                        }}
                    >
                        {renderSteps(windowsSteps)}
                    </div>
                </div>

                {/* Инструкция macOS */}
                <div className={p.section} onClick={() => toggle('macos')}>
                    <p className={p.section_title}>
                        Инструкция по настройке macOS:
                        <span className={`${p.arrow} ${active === 'macos' ? p.arrow_open : ''}`}>▾</span>
                    </p>
                    <div
                        ref={macosRef}
                        className={p.instruction_body}
                        style={{
                            maxHeight: getHeight(macosRef, 'macos'),
                            opacity: active === 'macos' ? 1 : 0,
                        }}
                    >
                        {renderSteps(macosSteps)}
                    </div>
                </div>

                {/* Инструкция Linux */}
                <div className={p.section} onClick={() => toggle('linux')}>
                    <p className={p.section_title}>
                        Инструкция по настройке Linux:
                        <span className={`${p.arrow} ${active === 'linux' ? p.arrow_open : ''}`}>▾</span>
                    </p>
                    <div
                        ref={linuxRef}
                        className={p.instruction_body}
                        style={{
                            maxHeight: getHeight(linuxRef, 'linux'),
                            opacity: active === 'linux' ? 1 : 0,
                        }}
                    >
                        {renderSteps(linuxSteps)}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Profile;